<template>
  <a
    :href="href"
    :class="[
      sizes,
      variants,
      'inline-flex',
      'items-center',
      'font-light',
      'rounded-md',
      'text-white',
      'transition-colors'
    ]"
  >
    <slot />
  </a>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    /** URL for this anchor button */
    href: {
      required: true,
      type: String
    },
    /** Smaller than default */
    size: String,
    /** Uppercase the button text */
    uppercase: Boolean,
    /** Add an outline around the button */
    outlined: Boolean,
    /** Applies a solid color */
    primary: Boolean
  },
  computed: {
    variants(): { [className: string]: boolean } {
      const { uppercase, outlined, primary } = this;
      return {
        // Outlined
        border: outlined,
        "border-white": outlined,
        // Uppercase
        uppercase: uppercase,
        // Colors
        "hover:bg-opacity-10": !primary,
        "hover:bg-white": !primary,
        "bg-samplyBlue": primary,
        "hover:bg-opacity-80": primary
      };
    },
    sizes(): { [className: string]: boolean } {
      switch (this.size) {
        case "small":
          return {
            "text-normal": true,
            "px-4": true,
            "py-2": true
          };
        default:
          return {
            "text-lg": true,
            "px-5": true,
            "py-3": true
          };
      }
    }
  }
});
</script>
